// src/Router.tsx

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAppContext } from './shared/context/AppContext';

// Pages
import LoginPage from './modules/auth/pages/LoginPage';
import AcademyDashboard from './modules/academy/pages/AcademyDashboard';
import CompetitionsList from './modules/competitions/pages/CompetitionsList';
import CompetitionDetail from './modules/competitions/pages/CompetitionDetail';
import MyCompetitions from './modules/competitions/pages/MyCompetitions';
import CategoryImagesView from './modules/competitions/pages/CategoryImagesView';
import JudgeCategorySelection from './modules/competitions/components/JudgeCategorySelection';
import JudgeEvaluations from './modules/competitions/pages/JudgeEvaluations';
import JudgeMyEvaluations from './modules/competitions/pages/JudgeMyEvaluations';
import JudgeParticipantsList from './modules/competitions/pages/JudgeParticipantsList';
import JudgeParticipantEvaluation from './modules/competitions/pages/JudgeParticipantEvaluation';

// Componente para rutas protegidas
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { state } = useAppContext();

  if (!state.auth.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

// Componente para rutas públicas (solo para no autenticados)
const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { state } = useAppContext();

  if (state.auth.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

const AppRouter: React.FC = () => {
  return (
    <Routes>
      {/* Rutas públicas */}
      <Route path="/login" element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      } />

      {/* Rutas protegidas */}
      <Route path="/" element={
        <ProtectedRoute>
          <AcademyDashboard />
        </ProtectedRoute>
      } />

      <Route path="/competitions" element={
        <ProtectedRoute>
          <CompetitionsList />
        </ProtectedRoute>
      } />

      <Route path="/competitions/:id" element={
        <ProtectedRoute>
          <CompetitionDetail />
        </ProtectedRoute>
      } />

      <Route path="/my-competitions" element={
        <ProtectedRoute>
          <MyCompetitions />
        </ProtectedRoute>
      } />

      {/* ✅ CORREGIDO: Ahora está protegida */}
      <Route path="/competitions/category/:categoryId/images" element={
        <ProtectedRoute>
          <CategoryImagesView />
        </ProtectedRoute>
      } />


      {/* Selección de categorías para juez */}
      <Route path="/competitions/:id/judge/categories" element={
        <ProtectedRoute>
          <JudgeCategorySelection />
        </ProtectedRoute>
      } />

      {/* Panel de evaluaciones del juez */}
      <Route path="/judge/evaluations/:eventId" element={
        <ProtectedRoute>
          <JudgeEvaluations />
        </ProtectedRoute>
      } />

      {/* Historial de mis evaluaciones */}
      <Route path="/judge/my-evaluations" element={
        <ProtectedRoute>
          <JudgeMyEvaluations />
        </ProtectedRoute>
      } />



      
      {/* ✅ CORREGIDO: Lista de participantes (PROTEGIDA) */}
      <Route path="/competitions/judge/:eventId/evaluations" element={
        <ProtectedRoute>
          <JudgeParticipantsList />
        </ProtectedRoute>
      } />

      {/* ✅ CORREGIDO: Evaluación individual de participante (PROTEGIDA) */}
      <Route path="/competitions/judge/:eventId/participant/:participantId" element={
        <ProtectedRoute>
          <JudgeParticipantEvaluation />
        </ProtectedRoute>
      } />
      
      {/* Ruta 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRouter;